import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { Spin } from "antd";
import AreaChart from "../../components/chart/AreaChart";
import ColumnBarChart from "../../components/chart/ColumnBarChart";
import { GetAdminDashboardApi } from "../../api/request/dashboard/dashboard";

const Dashboard = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dashboardCards, setDashboardCards] = useState([
    {
      title: "Unsubmitted Files",
      total: 0,
      icon: "/assets/icons/pending-tickets.svg",
      bgColor: "bg-[#cfcced]",
      path: "/files_report",
      state: { status: "unsubmitted" },
    },
    {
      title: "Inprocess Files",
      total: 0,
      icon: "/assets/icons/overdue-files.svg",
      bgColor: "bg-[#cdd8ec]",
      path: "/files_report",
      state: { status: "inprocess" },
    },
    {
      title: "Closed Files",
      total: 0,
      icon: "/assets/icons/active-job-files.svg",
      bgColor: "bg-[#E5FAFF]",
      path: "/files_report",
      state: { status: "closed" },
    },
    {
      title: "Interac E-transfer Payments",
      total: 0,
      icon: "/assets/icons/completed-files.svg",
      bgColor: "bg-[#DDF6E8]",
      path: "/payments_report",
      state: { type: "interac" },
    },
  ]);
  const [taskData, setTaskData] = useState({
    categories: [],
    series: [],
  });

  const totalClientData = {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    series: [{ name: "Client", data: [12, 10, 28, 8, 19, 34, 50] }],
  };
  const signatureData = {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    series: [{ name: "Client", data: [12, 10, 28, 16, 31, 21, 38] }],
  };

  const getDashboard = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetAdminDashboardApi();
      setData(data?.data);
      if (data?.status) {
        const updatedTotals = [
          data?.data?.unsubmitted_files,
          data?.data?.in_process_files,
          data?.data?.closed_files,
          data?.data?.interac_e_transfer_payments,
        ];
        setDashboardCards(
          dashboardCards.map((card, index) => ({
            ...card,
            total: updatedTotals[index] || 0,
          }))
        );
        const chartData = data.data.chart_data || [];
        const taskData = {
          categories: Array.isArray(chartData)
            ? chartData.map((item) => moment(item.date).format("MMM DD"))
            : [],
          series: [
            {
              name: "Closed",
              data: Array.isArray(chartData)
                ? chartData.map((item) => item.completed_tasks || 0)
                : [],
            },
            {
              name: "Inprocess",
              data: Array.isArray(chartData)
                ? chartData.map((item) => item.running_tasks || 0)
                : [],
            },
          ],
        };
        setTaskData(taskData);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDashboard();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center flex-col mt-[20%]">
          <Spin size="large" />
          <p className="primary text-center mt-2">Loading...</p>
        </div>
      ) : (
        <div>
          <div className="grid sm:grid-cols-4 gap-3">
            {dashboardCards.map((item, index) => (
              <div
                key={index}
                className="border rounded-xl p-4 bg-white cursor-pointer"
                onClick={() => navigate(item?.path, { state: item?.state })}
              >
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium">{item.title}</p>
                    <p className="font-semibold text-2xl mt-2">{item.total}</p>
                  </div>
                  <div
                    className={`${item.bgColor} rounded-xl size-14 flex items-center justify-center`}
                  >
                    <img src={item.icon} alt="icon" />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="grid xl:grid-cols-5 gap-5 mt-5">
            <div className="xl:col-span-3 border rounded-xl bg-white flex justify-center items-end flex-col">
              <div className="flex items-center justify-end gap-3 text-sm px-10 mb-3">
                <p>
                  <span className="text-xl text-secondary">●</span> Closed
                </p>
                <p>
                  <span className="text-xl text-Gray ">●</span> Inprocess
                </p>
              </div>
              <div className="w-full">
                <ColumnBarChart
                  categories={taskData.categories}
                  series={taskData.series}
                />
              </div>
            </div>
            <div className="grid col-span-2 sm:grid-cols-2 gap-5">
              <div className="bg-white border rounded-xl cursor-pointer" onClick={() => navigate("/clients")}>
                <div className="px-4 pt-4">
                  <h4 className="text-Gray text-lg">Total Client</h4>
                  <h2 className="text-2xl font-semibold">
                    {data?.total_clients || 0}
                  </h2>
                </div>
                <AreaChart
                  data={totalClientData}
                  colors={["#7367F0"]}
                  height={80}
                />
              </div>
              <div
                className="bg-white border rounded-xl cursor-pointer"
                onClick={() => navigate("/signature_report")}
              >
                <div className="px-4 pt-4">
                  <h4 className="text-Gray text-lg">Signature</h4>
                  <h2 className="text-2xl font-semibold">
                    {data?.signature || 0}
                  </h2>
                </div>

                <AreaChart
                  data={signatureData}
                  colors={["#03C3EC"]}
                  height={80}
                />
              </div>

              <div
                className="bg-white col-span-2 border rounded-xl cursor-pointer p-4 grid content-center gap-4"
                onClick={() => navigate("/files_report")}
              >
                <div className="">
                  <div className="flex justify-between">
                    <h4 className="text text-lg mb-3 font-semibold">Files :</h4>
                    <h4 className="text-lg text-center">
                      Total : {data?.total_files || 0} Files
                    </h4>
                  </div>
                  <hr className="mb-3" />
                  <div className="grid grid-cols-3 gap-4 ">
                    <div  className="flex flex-col justify-center items-center">
                      <div className="flex items-center gap-2">
                        <img src="/assets/icons/outlined-cross.svg" alt="icon" />
                        <h4 className="text-Gray text-lg">Unsubmitted</h4>
                      </div>
                      <h4 className="text-lg  text-center">
                        {data?.unsubmitted_files || 0} Files
                      </h4>
                    </div>
                    <div className="flex flex-col justify-center items-center">
                      <div className="flex items-center gap-2">
                        <img src="/assets/icons/outlined-timer.svg" alt="icon" />
                        <h4 className="text-Gray text-lg">In Process</h4>
                      </div>
                      <h4 className="text-lg  text-center">
                        {data?.in_process_files || 0} Files
                      </h4>
                    </div>
                    <div className="flex flex-col justify-center items-center">
                      <div className="flex items-center gap-2">
                        <img src="/assets/icons/outlined-check.svg" alt="icon" />
                        <h4 className="text-Gray text-lg">Closed</h4>
                      </div>
                      <h4 className="text-lg  text-center">
                        {data?.closed_files || 0} Files
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="bg-white col-span-2 border rounded-xl cursor-pointer p-4 grid content-center gap-4"
                onClick={() => navigate("/invoice_report")}
              >
                <div>
                  <div className="flex justify-between">
                    <h4 className="text-lg mb-3 font-semibold">Invoices :</h4>
                    <h4 className="text-lg text-center">
                      Total : {data?.total_invoice || 0} Invoices
                    </h4>
                  </div>
                  <hr className="mb-3" />
                  <div className="flex justify-around">
                    <div>
                      <div className="flex items-center gap-2">
                        <img src="/assets/icons/outlined-cross.svg" alt="icon" />
                        <h4 className="text-Gray text-lg">Unpaid</h4>
                      </div>
                      <h4 className="text-lg  text-center">
                        {data?.unpaid_invoice || 0} Invoice
                      </h4>
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <img src="/assets/icons/outlined-check.svg" alt="icon" />
                        <h4 className="text-Gray text-lg">Paid</h4>
                      </div>
                      <h4 className="text-lg  text-center">
                        {data?.paid_invoice || 0} Invoice
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div
                className="bg-white border rounded-xl cursor-pointer grid content-center gap-4 p-4"
                onClick={() => navigate("/invoice_report")}
              >
                <div className="flex justify-between gap-2">
                  <h4 className="text-Gray text-lg">Unpaid Invoice :</h4>
                  <h4 className="text-lg font-semibold">
                    {data?.unpaid_invoice || 0}
                  </h4>
                </div>
                <div className="flex justify-between gap-2">
                  <h4 className="text-Gray text-lg">Paid Invoice :</h4>
                  <h4 className="text-lg font-semibold">
                    {data?.paid_invoice || 0}
                  </h4>
                </div>
                <div className="flex justify-between gap-2">
                  <h4 className="text-Gray text-lg">Total Invoice :</h4>
                  <h4 className="text-lg font-semibold">
                    {data?.total_invoice || 0}
                  </h4>
                </div>
              </div> */}


            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
